export default __webpack_public_path__ + "static/media/entertainment.7eb94c42.jpg";